export const storeConstants = {
    SET_AUTHENTICATION: '@@AUTHENTICATION/SET_AUTHENTICATION'
};
